// import basket from './modules/basket';
import bikeTheftClaimFlow from './modules/bikeTheftClaimFlow';
import Events from './modules/Events.js';
import general from './modules/general.js';
import header from './modules/header.js';
import policy from './modules/policy/index';
import search from './modules/search';
import marketingBox from './modules/marketingBox';
import cprConsent from './modules/cprConsent';
import createMember from './modules/createMember';
import claimQuestionTree from './modules/claimQuestionTree';
// import newsletterSignupByEmail from './modules/newsletterSignupByEmail';
import quickQuote from './modules/quickQuote';
import proposalBasket from './modules/proposalBasket';
import paymentFrequency from './modules/paymentFrequency';
import dismissedItems from './modules/dismissedItems';
import type { RootState } from './modules/interfaces/RootState';
//import validations from './modules/validation.js';
// import { find } from 'lodash';
import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex';

// const whiteList = [
//   'dev-minside',
//   'local',
//   'local-ekstranet',
//   'tt1',
//   'tt1-minside',
//   'tt1-ekstranet',
//   'tt2',
//   'tt2-minside',
//   'tt2-ekstranet',
//   'tt3',
//   'tt3-minside',
//   'tt3-ekstranet',
//   'tt4',
//   'tt4-minside',
//   'tt4-ekstranet',
//   'tt5',
//   'tt5-minside',
//   'tt5-ekstranet',
//   'tt6',
//   'tt6-minside',
//   'tt6-ekstranet',
//   'tt7',
//   'tt7-minside',
//   'tt7-ekstranet',
//   'tt8',
//   'tt8-minside',
//   'tt8-ekstranet',
//   'aztt1',
//   'aztt1-minside',
//   'aztt1-ekstranet',
//   'ct',
//   'ct-minside',
//   'ct-ekstranet',
//   'qa10',
//   'qa10-minside',
//   'qa10-ekstranet',
//   'qa10a',
//   'qa10a-minside',
//   'qa10a-ekstranet',
//   'qa10b',
//   'qa10b-minside',
//   'qa10b-ekstranet',
//   'pp10',
//   'pp10-minside',
//   'pp10-ekstranet',
//   'pp10a',
//   'pp10a-minside',
//   'pp10a-ekstranet',
//   'pp10b',
//   'pp10b-minside',
//   'pp10b-ekstranet',
//   'qa',
//   'qa-minside',
//   'qa-ekstranet',
//   'preprod',
//   'preprod-minside',
//   'preprod-ekstranet',
//   'preprod1',
//   'preprod1-minside',
//   'preprod1-ekstranet',
//   'preprod2',
//   'preprod2-minside',
//   'preprod2-ekstranet'
// ];

// if (whiteList.length > 0 && find(whiteList, (e) => e === location.hostname.split('.')[0])) {
//   Vue.config.devtools = true;
// }

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  reducer: (state) => ({
    dismissedItems: {
      itemsDismissedTillDate: state.dismissedItems.itemsDismissedTillDate
    }
  })
});

const vuexSession = new VuexPersistence<RootState>({
  storage: window.sessionStorage,
  reducer: (state) => ({
    dismissedItems: {
      itemsDismissedInSession: state.dismissedItems.itemsDismissedInSession
    },
    proposalBasket: {
      selectedProposals: state.proposalBasket.selectedProposals,
      selectedPaymentIntervals: state.proposalBasket.selectedPaymentIntervals
    },
    search: {
      userUuid: state.search.userUuid
    }
  })
});

const store = createStore({
  modules: {
    header,
    search,
    general,
    policy,
    Events,
    // basket,
    proposalBasket,
    bikeTheftClaimFlow,
    marketingBox,
    cprConsent,
    createMember,
    claimQuestionTree,
    // newsletterSignupByEmail,
    quickQuote,
    dismissedItems,
    paymentFrequency
    //validations
  },
  strict: false,
  plugins: [vuexSession.plugin, vuexLocal.plugin]
});

export default store;
